/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductCategoryResponseDto } from './ProductCategoryResponseDto';
import {
    ProductCategoryResponseDtoFromJSON,
    ProductCategoryResponseDtoFromJSONTyped,
    ProductCategoryResponseDtoToJSON,
} from './ProductCategoryResponseDto';
import type { ProductSubBrandResponseDto } from './ProductSubBrandResponseDto';
import {
    ProductSubBrandResponseDtoFromJSON,
    ProductSubBrandResponseDtoFromJSONTyped,
    ProductSubBrandResponseDtoToJSON,
} from './ProductSubBrandResponseDto';
import type { ProductPriceResponseDto } from './ProductPriceResponseDto';
import {
    ProductPriceResponseDtoFromJSON,
    ProductPriceResponseDtoFromJSONTyped,
    ProductPriceResponseDtoToJSON,
} from './ProductPriceResponseDto';
import type { ProductBrandResponseDto } from './ProductBrandResponseDto';
import {
    ProductBrandResponseDtoFromJSON,
    ProductBrandResponseDtoFromJSONTyped,
    ProductBrandResponseDtoToJSON,
} from './ProductBrandResponseDto';
import type { ProductSubCategoryResponseDto } from './ProductSubCategoryResponseDto';
import {
    ProductSubCategoryResponseDtoFromJSON,
    ProductSubCategoryResponseDtoFromJSONTyped,
    ProductSubCategoryResponseDtoToJSON,
} from './ProductSubCategoryResponseDto';

/**
 * 
 * @export
 * @interface ProductResponseDto
 */
export interface ProductResponseDto {
    /**
     * Product ID
     * @type {number}
     * @memberof ProductResponseDto
     */
    id: number;
    /**
     * Product SKU
     * @type {string}
     * @memberof ProductResponseDto
     */
    sku: string;
    /**
     * Product name in Arabic
     * @type {string}
     * @memberof ProductResponseDto
     */
    nameAr: string;
    /**
     * Product name in English
     * @type {string}
     * @memberof ProductResponseDto
     */
    nameEn: string;
    /**
     * Product description in Arabic
     * @type {string}
     * @memberof ProductResponseDto
     */
    descriptionAr: string | null;
    /**
     * Product description in English
     * @type {string}
     * @memberof ProductResponseDto
     */
    descriptionEn: string | null;
    /**
     * Array of product image URLs
     * @type {Array<string>}
     * @memberof ProductResponseDto
     */
    imageUrls: Array<string>;
    /**
     * Whether product is in stock
     * @type {boolean}
     * @memberof ProductResponseDto
     */
    inStock: boolean | null;
    /**
     * Product brand information
     * @type {ProductBrandResponseDto}
     * @memberof ProductResponseDto
     */
    brand: ProductBrandResponseDto;
    /**
     * Product category information
     * @type {ProductCategoryResponseDto}
     * @memberof ProductResponseDto
     */
    category: ProductCategoryResponseDto;
    /**
     * Product sub-brand information
     * @type {ProductSubBrandResponseDto}
     * @memberof ProductResponseDto
     */
    subBrand: ProductSubBrandResponseDto;
    /**
     * Product sub-category information
     * @type {ProductSubCategoryResponseDto}
     * @memberof ProductResponseDto
     */
    subCategory: ProductSubCategoryResponseDto;
    /**
     * Product barcode
     * @type {string}
     * @memberof ProductResponseDto
     */
    barcode: string | null;
    /**
     * Product prices in different currencies
     * @type {Array<ProductPriceResponseDto>}
     * @memberof ProductResponseDto
     */
    price: Array<ProductPriceResponseDto>;
    /**
     * Tax rate as percentage
     * @type {number}
     * @memberof ProductResponseDto
     */
    taxRate: number | null;
    /**
     * Discount rate as percentage
     * @type {number}
     * @memberof ProductResponseDto
     */
    discountRate: number | null;
    /**
     * Product length in centimeters
     * @type {number}
     * @memberof ProductResponseDto
     */
    length: number | null;
    /**
     * Product width in centimeters
     * @type {number}
     * @memberof ProductResponseDto
     */
    width: number | null;
    /**
     * Product height in centimeters
     * @type {number}
     * @memberof ProductResponseDto
     */
    height: number | null;
    /**
     * Product weight in kilograms
     * @type {number}
     * @memberof ProductResponseDto
     */
    weight: number | null;
    /**
     * Whether product is disabled
     * @type {boolean}
     * @memberof ProductResponseDto
     */
    disabled: boolean;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof ProductResponseDto
     */
    createdAt: Date;
    /**
     * Last update timestamp
     * @type {Date}
     * @memberof ProductResponseDto
     */
    updatedAt: Date;
    /**
     * Product catalog ID
     * @type {Array<string>}
     * @memberof ProductResponseDto
     */
    catalogItems?: Array<string>;
    /**
     * Maximum order quantity for the product
     * @type {number}
     * @memberof ProductResponseDto
     */
    maximumOrderQty?: number;
    /**
     * Minimum order quantity for the product
     * @type {number}
     * @memberof ProductResponseDto
     */
    minimumOrderQty?: number;
    /**
     * Product volume. This property is dynamically calculated and is not persisted in the database.
     * @type {number}
     * @memberof ProductResponseDto
     */
    volume?: number;
    /**
     * Product footprint. This property is dynamically calculated and is not persisted in the database.
     * @type {number}
     * @memberof ProductResponseDto
     */
    footprint?: number;
}

/**
 * Check if a given object implements the ProductResponseDto interface.
 */
export function instanceOfProductResponseDto(value: object): value is ProductResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sku' in value) || value['sku'] === undefined) return false;
    if (!('nameAr' in value) || value['nameAr'] === undefined) return false;
    if (!('nameEn' in value) || value['nameEn'] === undefined) return false;
    if (!('descriptionAr' in value) || value['descriptionAr'] === undefined) return false;
    if (!('descriptionEn' in value) || value['descriptionEn'] === undefined) return false;
    if (!('imageUrls' in value) || value['imageUrls'] === undefined) return false;
    if (!('inStock' in value) || value['inStock'] === undefined) return false;
    if (!('brand' in value) || value['brand'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('subBrand' in value) || value['subBrand'] === undefined) return false;
    if (!('subCategory' in value) || value['subCategory'] === undefined) return false;
    if (!('barcode' in value) || value['barcode'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('taxRate' in value) || value['taxRate'] === undefined) return false;
    if (!('discountRate' in value) || value['discountRate'] === undefined) return false;
    if (!('length' in value) || value['length'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('disabled' in value) || value['disabled'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ProductResponseDtoFromJSON(json: any): ProductResponseDto {
    return ProductResponseDtoFromJSONTyped(json, false);
}

export function ProductResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sku': json['sku'],
        'nameAr': json['nameAr'],
        'nameEn': json['nameEn'],
        'descriptionAr': json['descriptionAr'],
        'descriptionEn': json['descriptionEn'],
        'imageUrls': json['imageUrls'],
        'inStock': json['inStock'],
        'brand': ProductBrandResponseDtoFromJSON(json['brand']),
        'category': ProductCategoryResponseDtoFromJSON(json['category']),
        'subBrand': ProductSubBrandResponseDtoFromJSON(json['subBrand']),
        'subCategory': ProductSubCategoryResponseDtoFromJSON(json['subCategory']),
        'barcode': json['barcode'],
        'price': ((json['price'] as Array<any>).map(ProductPriceResponseDtoFromJSON)),
        'taxRate': json['taxRate'],
        'discountRate': json['discountRate'],
        'length': json['length'],
        'width': json['width'],
        'height': json['height'],
        'weight': json['weight'],
        'disabled': json['disabled'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'catalogItems': json['catalogItems'] == null ? undefined : json['catalogItems'],
        'maximumOrderQty': json['maximumOrderQty'] == null ? undefined : json['maximumOrderQty'],
        'minimumOrderQty': json['minimumOrderQty'] == null ? undefined : json['minimumOrderQty'],
        'volume': json['volume'] == null ? undefined : json['volume'],
        'footprint': json['footprint'] == null ? undefined : json['footprint'],
    };
}

export function ProductResponseDtoToJSON(value?: ProductResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'sku': value['sku'],
        'nameAr': value['nameAr'],
        'nameEn': value['nameEn'],
        'descriptionAr': value['descriptionAr'],
        'descriptionEn': value['descriptionEn'],
        'imageUrls': value['imageUrls'],
        'inStock': value['inStock'],
        'brand': ProductBrandResponseDtoToJSON(value['brand']),
        'category': ProductCategoryResponseDtoToJSON(value['category']),
        'subBrand': ProductSubBrandResponseDtoToJSON(value['subBrand']),
        'subCategory': ProductSubCategoryResponseDtoToJSON(value['subCategory']),
        'barcode': value['barcode'],
        'price': ((value['price'] as Array<any>).map(ProductPriceResponseDtoToJSON)),
        'taxRate': value['taxRate'],
        'discountRate': value['discountRate'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'weight': value['weight'],
        'disabled': value['disabled'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'catalogItems': value['catalogItems'],
        'maximumOrderQty': value['maximumOrderQty'],
        'minimumOrderQty': value['minimumOrderQty'],
        'volume': value['volume'],
        'footprint': value['footprint'],
    };
}

